import React, { Component } from 'react'
import Select from 'react-select-plus'
import moment from 'moment'
import IconSVG from 'svg-inline-react'
import { DAY_RANGES, DAYS } from 'components/Customize/Availability/Constants'
import styles from './style.styl'

import closeIconSrc from '!svg-inline?removeTags=true&removeSVGTagAttrs=false!images/svg/dismiss.svg'

const HOUR_LABEL_FORMAT = 'h:mma'
const HOUR_FORMAT = 'H:mm'

const HOUR_OPTIONS = _.range(24)
  .reduce((result, hour) => {
    const topValue = `${hour}:0`
    const midValue = `${hour}:30`
    result.push({ value: topValue, label: moment(topValue, HOUR_FORMAT).format(HOUR_LABEL_FORMAT) })
    result.push({ value: midValue, label: moment(midValue, HOUR_FORMAT).format(HOUR_LABEL_FORMAT) })
    return result
  }, [])
  .concat([{ value: '23:59', label: '12:00AM' }])

export const DAY_OPTIONS = DAY_RANGES.concat(DAYS)
  .map(day => ({
    label: day.charAt(0) + day.substring(1).toLowerCase(),
    value: day,
  }))
  .toJS()

class AvailabilitySlotSelect extends Component {
  handleSelectDayOfWeek = ({ value }) => {
    this.props.onSelectDayOfWeek(this.props.index, value)
  }

  handleSelectStartTime = ({ value }) => {
    const [hour, minutes] = value.split(':').map(x => parseInt(x))
    this.props.onSelectStartTime(this.props.index, { hour, minutes })
  }

  handleSelectEndTime = ({ value }) => {
    const [hour, minutes] = value.split(':').map(x => parseInt(x))
    this.props.onSelectEndTime(this.props.index, { hour, minutes })
  }

  render() {
    const { dayOfWeek, startTime, endTime, onRemove, index, hideRemove } = this.props

    const startTimeValue = `${startTime.hour}:${startTime.minutes}`
    const endTimeValue = `${endTime.hour}:${endTime.minutes}`

    return (
      <div className={styles.TimeSelect}>
        <Select
          className="day"
          value={dayOfWeek}
          options={DAY_OPTIONS}
          searchable={false}
          clearable={false}
          onChange={this.handleSelectDayOfWeek}
        />
        <span>from</span>
        <Select
          className="time"
          value={startTimeValue}
          options={HOUR_OPTIONS}
          searchable={false}
          clearable={false}
          onChange={this.handleSelectStartTime}
        />
        <span>to</span>
        <Select
          className="time"
          value={endTimeValue}
          options={HOUR_OPTIONS}
          searchable={false}
          clearable={false}
          onChange={this.handleSelectEndTime}
        />
        {!hideRemove && (
          <a
            onClick={() => {
              onRemove(index)
            }}
            style={{ width: 11, height: 11 }}
          >
            <IconSVG className="availability-remove" src={closeIconSrc} />
          </a>
        )}
      </div>
    )
  }
}

export default AvailabilitySlotSelect



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/AvailabilitySlotSelect/index.js